<script lang="ts">
import type { NuxtError } from "#app";

/**
 * Generic error page for handling unexpected errors.
 */
export default {
  name: "ErrorPage",
  props: {
    error: {
      type: Object as PropType<NuxtError>,
      required: true,
    },
  },
  mounted() {
    // eslint-disable-next-line no-console
    const err = this.error ?? {};
    console.error(`Error page mounted - original error object: ${JSON.stringify(err, null, 2)}`);
  },
  methods: {
    handleError() {
      clearError({ redirect: "/" });
    },
  },
};
</script>

<template>
  <div class="flex min-h-screen items-start justify-center bg-gray-200 p-6">
    <div class="mx-auto mt-16 max-w-sm rounded-lg bg-white p-8 shadow-lg">
      <div class="text-center">
        <h1 class="mb-4 text-4xl font-bold text-red-600">{{ error.statusCode }}</h1>
        <p class="mb-6 text-lg font-semibold text-gray-800">Oops! Something went wrong.</p>
        <p class="mb-8 text-gray-600">
          We encountered an unexpected error. Please try again later or contact support if the
          problem persists.
        </p>
        <button
          class="inline-block rounded-lg bg-blue-500 px-6 py-3 font-semibold text-white shadow hover:bg-blue-600"
          @click="handleError"
        >
          Go to Home
        </button>
      </div>
    </div>
  </div>
</template>
